module.exports = __webpack_public_path__ + "img/circle_check_black_unchecked.18e9aad6.svg";